import {
  DefaultPage,
  AddCollectionInProject,
  AddMorePlugin,
  ProjectOnBoardFinal,
  XanoCollection,
  XanoProjectslist,
  XanoCollectionNameList,
  XanoTableData,
} from './';
// import XanoCollectionName from './XanoCollectionName';

export default {
  path: 'project-on-board/:version/v',
  name: 'Project on board',
  childRoutes: [
    { path: ':projectId', name: 'Default page', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/loader',
      name: 'Default page with Loader',
      component: DefaultPage,
      isPrivate: true,
    },
    {
      path: ':projectId/add-collection',
      name: 'Add collection in project',
      component: AddCollectionInProject,
      isPrivate: true,
    },
    {
      path: ':projectId/add-more-plugin',
      name: 'Add more plugin',
      component: AddMorePlugin,
      isPrivate: true,
    },
    {
      path: ':projectId/final-step',
      name: 'Project on board final',
      component: ProjectOnBoardFinal,
      isPrivate: true,
    },
    {
      path: ':projectId/xano-create-collection',
      name: 'Xano collection',
      component: XanoCollection,
      isPrivate: true,
    },
    {
      path: ':projectId/xano-projectslist',
      name: 'Xano projectslist',
      component: XanoProjectslist,
      isPrivate: true,
    },
    {
      path: ':projectId/xano-collection-namelist',
      name: 'Xano collection name list',
      component: XanoCollectionNameList,
      isPrivate: true,
    },
    {
      path: ':projectId/xano-collection-namelist/xano-tables/:dbUuid',
      name: 'Xano table data',
      component: XanoTableData,
      isPrivate: true,
    },
  ],
};
